import React, {useEffect, useState} from 'react';
import {Modal, Button, Table, Popup, Loader, Dimmer} from 'semantic-ui-react';
import styles from '../DataInspector.module.css';
import {useDataInspector} from '../../../providers/DataInspectorProvider';

const emptyData = {
  timestamp: '',
  missingData: [],
  targetData: [],
  otherData: [],
};

function titleCase(string) {
  return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

function isNull(value) {
  if (value === null || typeof value === 'undefined') {
    return true;
  } else {
    return false;
  }
}

function isUndefined(value) {
  if (typeof value === 'undefined') {
    return true;
  } else {
    return false;
  }
}

function ErrorCell(func) {
  console.log(func);
  if (!isNull(func.error) && !func.error) {
    return (
      <span className={styles.trueCell}>
        {isUndefined(func.error) ? 'N/A' : titleCase(func.error.toString())}
      </span>
    );
  } else {
    return (
      <Popup
        content={func.errorMessage}
        trigger={
          <span className={styles.errorCell}>
            {isUndefined(func.error) ? 'N/A' : titleCase(func.error.toString())}
          </span>
        }
      />
    );
  }
}

export const FunctionDiagnostics = ({open, setOpen, rowData}) => {
  const [data, setData] = useState(emptyData);

  const {getFunctionDiagnostics} = useDataInspector();

  useEffect(() => {
    async function fetchData() {
      if (rowData != null) {
        let query = {
          EquipmentId: rowData.objectId,
          FunctionId: rowData.function.functionIds,
          Timestamp: rowData.normalizedTime,
        };
        const functionDiagnosticsResponse = await getFunctionDiagnostics(query);
        setData(functionDiagnosticsResponse);
      }
    }

    fetchData();
  }, [getFunctionDiagnostics, rowData]);

  const clearStates = () => {
    setData(emptyData);
  };

  const handleClose = () => {
    setOpen(false);
    clearStates();
  };

  return (
    <>
      <Modal
        closeIcon
        onClose={() => handleClose()}
        onOpen={() => setOpen(true)}
        open={open}
        style={{textAlign: 'left'}}
      >
        <Modal.Header>Function Diagnostics</Modal.Header>
        <Modal.Content>
          {data.timestamp !== '' ? (
            <>
              <div className={styles.diagnosticsHeader}>
                <div>
                  <span>Timestamp: </span> {data.timestamp ?? ''}
                </div>
                <div>
                  <span>EquipmentId: </span> {rowData?.objectId ?? ''}
                </div>
                <div>
                  <span>FunctionId: </span> {rowData?.function.functionIds ?? ''}
                </div>
              </div>
              {data.targetData.length > 0 ? (
                <>
                  <div className={styles.tableTitle}>Target Data</div>
                  <Table celled={true}>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Code</Table.HeaderCell>
                        <Table.HeaderCell>Object ID</Table.HeaderCell>
                        <Table.HeaderCell>Error</Table.HeaderCell>
                        <Table.HeaderCell>Type</Table.HeaderCell>
                        <Table.HeaderCell>Value</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    {data.targetData.map((func, i) => {
                      return (
                        <Table.Row>
                          <Table.Cell>{func.code}</Table.Cell>
                          <Table.Cell>{func.objectId}</Table.Cell>
                          <Table.Cell>
                            <ErrorCell error={func.error} errorMessage={func.errorMessage} />
                          </Table.Cell>
                          <Table.Cell>{func.type}</Table.Cell>
                          <Table.Cell>{func.value}</Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table>
                </>
              ) : (
                <div className={styles.tableTitle}>No missing data</div>
              )}
              {data.otherData.length > 0 ? (
                <>
                  <div className={styles.tableTitle}>Other Data</div>
                  <Table celled={true}>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Code</Table.HeaderCell>
                        <Table.HeaderCell>Object ID</Table.HeaderCell>
                        <Table.HeaderCell>Error</Table.HeaderCell>
                        <Table.HeaderCell>Type</Table.HeaderCell>
                        <Table.HeaderCell>Value</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    {data.otherData.map((func, i) => {
                      return (
                        <Table.Row>
                          <Table.Cell>{func.code}</Table.Cell>
                          <Table.Cell>{func.objectId}</Table.Cell>
                          <Table.Cell>
                            <ErrorCell error={func.error} errorMessage={func.errorMessage} />
                          </Table.Cell>
                          <Table.Cell>{func.type}</Table.Cell>
                          <Table.Cell>{func.value}</Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table>
                </>
              ) : (
                <div className={styles.tableTitle}>No other data</div>
              )}
              {data.missingData.length > 0 ? (
                <>
                  <div className={styles.tableTitle}>Missing Data</div>
                  <Table celled={true}>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Code</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    {data.missingData.map((functionCode, i) => {
                      return (
                        <Table.Row>
                          <Table.Cell>{functionCode}</Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table>
                </>
              ) : (
                <div className={styles.tableTitle}>No missing data</div>
              )}
            </>
          ) : (
            <div>
              <Dimmer active inverted>
                <Loader size={'large'}>Loading</Loader>
              </Dimmer>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => handleClose()}>Close</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
